// Code generated by Slice Machine. DO NOT EDIT.

import AztkPresentation from "./AztkPresentation";
import Blog from "./Blog";
import BlogList from "./BlogList";
import Contact from "./Contact";
import Faq from "./Faq";
import FooterMain from "./FooterMain";
import Form from "./Form";
import GuideList from "./GuideList";
import Hero from "./Hero";
import ImageText from "./ImageText";
import KeyPoints from "./KeyPoints";
import Krew from "./Krew";
import Logos from "./Logos";
import MenuItem from "./MenuItem";
import ProjectBulletList from "./ProjectBulletList";
import ProjectCard from "./ProjectCard";
import ProjectData from "./ProjectData";
import ProjectHighLight from "./ProjectHighLight";
import ProjectText from "./ProjectText";
import ProjectList from "./ProjectList";
import ProjectPicture from "./ProjectPicture";
import ProjectPresentation from "./ProjectPresentation";
import ProjectProjects from "./ProjectProjects";
import ProjectReview from "./ProjectReview";
import ProjectsList from "./ProjectsList";
import Carousel from "./Carousel";
import Services from "./Services";
import ServicesDisplay from "./ServicesDisplay";

export const components = {
  aztk_presentation: AztkPresentation,
  blog: Blog,
  blog_list: BlogList,
  contact: Contact,
  faq: Faq,
  footer_main: FooterMain,
  form: Form,
  guide_list: GuideList,
  hero: Hero,
  image_text: ImageText,
  key_points: KeyPoints,
  krew: Krew,
  logos: Logos,
  menu_item: MenuItem,
  project_bullet_list: ProjectBulletList,
  project_card: ProjectCard,
  project_data: ProjectData,
  project_high_light: ProjectHighLight,
  project_intro: ProjectText,
  project_list: ProjectList,
  project_picture: ProjectPicture,
  project_presentation: ProjectPresentation,
  project_projects: ProjectProjects,
  project_review: ProjectReview,
  projects_list: ProjectsList,
  review: Carousel,
  services: Services,
  services_display: ServicesDisplay,
};
